import React from 'react';
import './LoadingScreen.css';
import spiderLogo from '../../assets/images/logo2.png';

const LoadingScreen = ({ progress }) => {
    return (
        <div className="loading-screen">
            <div className="loading-content">
                <div className="loading-logo">
                    <img src={spiderLogo} alt="Spider Solitaire" />
                </div>
                <h1 className="loading-title">Spider Solitaire</h1>
                <div className="loading-progress-container">
                    <div 
                        className="loading-progress-bar" 
                        style={{ width: `${progress}%` }}
                    />
                </div>
                <p className="loading-text">Loading... {progress}%</p>
            </div>
        </div>
    );
};

export default LoadingScreen; 